import { useTargetingContext } from '@openx/components-targeting/utils/context/TargetingContext';
import { ACL_TYPE } from '@openx/types/aclType';
import { CuratedPackageAction, type Package } from '@openx/types/package';
import { UserRole } from '@openx/types/user';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators';
import { useMemo } from 'react';
import { usePackageContext } from '../context/PackageContext';

type PackagePayload = Pick<Package, 'locked_internal' | 'is_curated'>;

export const usePackageEditPermissions = (pckg?: PackagePayload) => {
  const { useCurrentInstanceState } = useTargetingContext();
  const { usePackagePermissions } = usePackageContext();
  const { isBefInstance } = useCurrentInstanceState();
  const { useIsAllowed } = usePermissionContext();
  const { isAllowed, accessUser } = useIsAllowed();
  const { hasCuratedPermission } = usePackagePermissions();

  const isOaBuyer = !!accessUser?.roles.includes(UserRole.NETWORK_OA_OPENX_BUYER);

  const isLockedForExternalUsers =
    isBefInstance &&
    !isAllowed(isAllowedByCompiledAcl(ACL_TYPE.INTERNAL_FIELD_WRITE)) &&
    !isOaBuyer &&
    pckg?.locked_internal;

  const isLockedForNonCurator = useMemo(
    () => !hasCuratedPermission({ action: CuratedPackageAction.UPDATE, pckg }),
    [hasCuratedPermission, pckg]
  );

  return {
    isLocked: isLockedForExternalUsers || isLockedForNonCurator,
    isLockedForExternalUsers,
    isLockedForNonCurator,
  };
};
